import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8787';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authService = {
  login: (username, password) => 
    api.post('/api/login', { username, password }),
};

export const extinguisherService = {
  create: (data) => 
    api.post('/api/extinguishers', data),
  
  getNearby: (lat, lng, radius = 50) => 
    api.get(`/api/extinguishers?lat=${lat}&lng=${lng}&radius=${radius}`),
  
  getClosest: (lat, lng, limit = 10) => 
    api.get(`/api/extinguishers?lat=${lat}&lng=${lng}&limit=${limit}&radius=1000`),
  
  getAll: () => 
    api.get('/api/admin/extinguishers'),
  
  delete: (id) => 
    api.delete(`/api/admin/extinguishers/${id}`),
};

export const userService = {
  getAll: () => 
    api.get('/api/admin/users'),
  
  create: (userData) => 
    api.post('/api/admin/users', userData),
  
  update: (id, userData) => 
    api.put(`/api/admin/users/${id}`, userData),
  
  delete: (id) => 
    api.delete(`/api/admin/users/${id}`),
  
  updatePassword: (id, password) => 
    api.put(`/api/admin/users/${id}/password`, { password }),
};

export const uploadService = {
  getUploadUrl: (filename, contentType) => 
    api.post('/api/upload-url', { filename, contentType }),
};

export const geocodeService = {
  reverseGeocode: async (lat, lng) => {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    if (!apiKey) {
      throw new Error('Google Maps API key not configured');
    }
    
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&result_type=street_address&key=${apiKey}`
    );
    
    if (!response.ok) {
      throw new Error('Geocoding failed');
    }
    
    const data = await response.json();
    if (data.results && data.results.length > 0) {
      return data.results[0].formatted_address;
    }
    
    throw new Error('No address found');
  },
};

export default api;